import { render, staticRenderFns } from "./text-edit.vue?vue&type=template&id=f9e11cea"
import script from "./text-edit.vue?vue&type=script&lang=ts"
export * from "./text-edit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports